var REACT_ELEMENT_TYPE;function _jsx(type, props, key, children) {REACT_ELEMENT_TYPE || (REACT_ELEMENT_TYPE = "function" == typeof Symbol && Symbol.for && Symbol.for("react.element") || 60103);var defaultProps = type && type.defaultProps,childrenLength = arguments.length - 3;if (props || 0 === childrenLength || (props = { children: void 0 }), 1 === childrenLength) props.children = children;else if (childrenLength > 1) {for (var childArray = new Array(childrenLength), i = 0; i < childrenLength; i++) childArray[i] = arguments[i + 3];props.children = childArray;}if (props && defaultProps) for (var propName in defaultProps) void 0 === props[propName] && (props[propName] = defaultProps[propName]);else props || (props = defaultProps || {});return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: void 0 === key ? null : "" + key, ref: null, props: props, _owner: null };} /* eslint-disable react/no-multi-comp */
import React, { useState } from 'react';
import moment from 'moment';

import { Icon } from "../../UI";
import { Translate } from "../../I18N";


import DescriptionWrapper from "./DescriptionWrapper";

const methodColor = {
  CREATE: 'btn-color-9',
  UPDATE: 'btn-color-6',
  DELETE: 'btn-color-2',
  RAW: 'btn-color-17',
  MIGRATE: 'btn-color-12',
  WARNING: 'btn-color-13'
};

const MethodLabel = ({ method }) => /*#__PURE__*/
_jsx("span", { className: `badge ${methodColor[method] || 'btn-color-13'}` }, void 0, /*#__PURE__*/
_jsx(Translate, {}, void 0, method),
method === 'WARNING' && /*#__PURE__*/_jsx(Icon, { icon: "exclamation-triangle" }));



const ActivitylogRow = ({ entry }) => {
  const [expanded, setExpanded] = useState(false);
  const toggleExpand = () => {
    setExpanded(!expanded);
  };

  const time = `${moment(entry.get('time')).format('L')} ${moment(entry.get('time')).
  locale('en').
  format('LTS')}`;
  const semanticData = entry.get('semantic').toJS();
  return /*#__PURE__*/(
    _jsx("tr", {
      className: semanticData.action === 'RAW' ? 'activitylog-raw' : 'activitylog-beautified' },
    entry.get('_id').toString(), /*#__PURE__*/

    _jsx("td", {}, void 0, /*#__PURE__*/
    _jsx(MethodLabel, { method: semanticData.action })), /*#__PURE__*/

    _jsx("td", { className: !entry.get('username') ? 'color-0' : '' }, void 0,
    entry.get('username') || 'anonymous'), /*#__PURE__*/

    _jsx("td", {}, void 0, /*#__PURE__*/
    _jsx(DescriptionWrapper, { entry: entry, toggleExpand: toggleExpand, expanded: expanded }, void 0, /*#__PURE__*/
    _jsx("span", {}, void 0,
    semanticData.description && /*#__PURE__*/
    _jsx("span", { className: "activitylog-prefix" }, void 0, /*#__PURE__*/
    _jsx(Translate, {}, void 0, semanticData.description)),


    semanticData.name && /*#__PURE__*/
    _jsx("span", { className: "activitylog-name" }, void 0, /*#__PURE__*/
    _jsx(Translate, {}, void 0, semanticData.name)),


    semanticData.extra && /*#__PURE__*/
    _jsx("span", { className: "activitylog-extra" }, void 0, /*#__PURE__*/
    _jsx(Translate, {}, void 0, semanticData.extra))))), /*#__PURE__*/





    _jsx("td", { className: "activitylog-time" }, void 0, time)));


};

export { ActivitylogRow };